import { styled, makeStyles, withStyles } from '@material-ui/core/styles';
import { IconButton, MenuItem, Menu } from '@material-ui/core';

import { Bogle_Regular, Bogle_Medium } from 'constants/constant';
import { colors } from 'theme/color-palette';

export const HelpIconButton = withStyles({
	root: {
		padding: '10px',
		margin: 'auto 8px'
	}
})(IconButton);

export const useStyles = makeStyles(() => ({
	trainingMenuItem: {
		width: '100%',
		display: 'flex',
		fontSize: '14px',
		alignItems: 'center',
		color: colors.FONT_COLOR,
		justifyContent: 'space-between'
	},
	contactSales: {
		gap: '8px',
		display: 'flex',
		fontSize: '14px',
		alignItems: 'center',
		color: colors.FONT_COLOR
	},
	launchIcon: {
		width: 15,
		height: 15,
		color: colors.FONT_COLOR
	},
	/* Modal */
	modalContainer: {
		position: 'fixed',
		background: 'white',
		width: '360px',
		borderRadius: '16px',
		boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
		overflowY: 'scroll'
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'all-scroll',
		padding: '16px 16px 8px 16px'
	},
	helpIcon: {
		width: '20px',
		height: '20px',
		marginRight: '16px',
		color: colors.PURPLE
	},
	title: {
		fontSize: '20px',
		fontWeight: 500,
		marginTop: '8px',
		marginBottom: '8px',
		fontFamily: `${Bogle_Medium} !important`
	},
	closeBtn: {
		width: '20px',
		height: '20px',
		padding: '18px',
		cursor: 'pointer',
		marginLeft: 'auto'
	},
	subHeader: {
		marginTop: '8px',
		padding: '8px 16px',
		display: 'flex',
		alignItems: 'center'
	},
	subTitle: {
		fontWeight: 500,
		fontSize: '16px',
		fontFamily: `${Bogle_Medium} !important`
	},
	subHeaderLink: {
		cursor: 'pointer',
		marginLeft: 'auto',
		fontSize: '14px',
		display: 'flex',
		gap: '4px'
	},
	articleIcon: {
		width: '18px !important',
		height: '18px !important',
		padding: '8px',
		borderRadius: '40px',
		color: colors.PURPLE,
		background: colors.TOGGLE_ACTIVE
	},
	articleItem: {
		fontSize: '16px',
		marginLeft: '16px',
		lineHeight: '24px',
		color: colors.FONT_COLOR
	},
	supportIcon: {
		width: '20px !important',
		height: '20px !important',
		color: colors.PURPLE,
		marginLeft: '8px',
		marginRight: '22px'
	},
	contactSupport: {
		padding: '8px 16px !important',
		marginTop: '8px !important',
		marginBottom: '8px !important'
	},
	contactSupportText: {
		color: colors.FONT_COLOR,
		fontSize: '16px',
		lineHeight: '24px'
	}
}));

export const HelpMenuItem = styled(MenuItem)({
	'&.MuiMenuItem-root': {
		fontSize: '14px',
		padding: '10px 16px',
		fontFamily: Bogle_Regular,
		color: colors.FONT_COLOR
	}
});

export const HelpLinkItem = styled(MenuItem)({
	'&.MuiMenuItem-root': {
		display: 'flex',
		alignItems: 'center',
		padding: '8px 0 8px 16px'
	}
});

export const HelpMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right'
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right'
		}}
		{...props}
	/>
))(() => ({
	'& .MuiPaper-root': {
		borderRadius: 4,
		marginTop: '4px',
		minWidth: 240,
		boxShadow: '0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);',
		'& .MuiMenuItem-root': {
			'&:active': {
				backgroundColor: colors.LIGHT_GRAY_SHADE
			}
		}
	}
}));
